<template>
	<div class='text'>
		<UserComponent :notification='notification' /> just become a certified agent in the <MarketComponent :notification='notification' /> market
	</div>
</template>

<script>
import UserComponent from '../UserComponent/UserComponent.vue';
import MarketComponent from '../MarketComponent/MarketComponent.vue';
export default {
	name:       'NewCertifiedAgentsText',
	components: {
		UserComponent,
		MarketComponent
	},
	props: {
		notification: {
			type: Object
		}
	}
};
</script>
